import { animate, group, query, style, transition, trigger } from '@angular/animations';

export const surveyAnimations = [
  trigger('fadeInOut', [
    transition(':enter', [style({ opacity: 0 }), animate('300ms', style({ opacity: 1 }))]),
    transition(':leave', [style({ height: 0 }), animate('300ms', style({ opacity: 0 }))]),
  ]),
  trigger('stepTransition', [
    transition(':increment', [
      query(':enter, :leave', style({ position: 'absolute', width: '100%' }), { optional: true }),
      query(':enter', style({ transform: 'translateY(100%)', opacity: 0 }), { optional: true }),
      group([
        query(':leave', [animate('300ms ease-out', style({ transform: 'translateY(-100%)', opacity: 0 }))], {
          optional: true,
        }),
        query(':enter', [animate('300ms ease-out', style({ transform: 'translateY(0)', opacity: 1 }))], {
          optional: true,
        }),
      ]),
    ]),
    transition(':decrement', [
      query(':enter, :leave', style({ position: 'absolute', width: '100%' }), { optional: true }),
      query(':enter', style({ transform: 'translateY(-100%)', opacity: 0 }), { optional: true }),
      group([
        query(':leave', [animate('300ms ease-out', style({ transform: 'translateY(100%)', opacity: 0 }))], {
          optional: true,
        }),
        query(':enter', [animate('300ms ease-out', style({ transform: 'translateY(0)', opacity: 1 }))], {
          optional: true,
        }),
      ]),
    ]),
  ]),
];
